import { getQuoteProperty } from 'quotes-ui-lib/utils/quote';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsFullySigned, getIsPublished } from 'quotes-ui-lib/utils/status';
import { memo, useCallback, useMemo } from 'react';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import UIFlex from 'UIComponents/layout/UIFlex';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DeleteQuoteModal = ({
  quote,
  isOpen,
  loading,
  onConfirm,
  onReject
}) => {
  const quotePublished = getIsPublished(quote);
  const quoteFullySigned = getIsFullySigned(quote);
  const quoteTitle = getQuoteProperty(quote, 'hs_title');
  const title = useMemo(() => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "quotesUiLib.deleteQuoteModal.title",
    options: {
      title: quoteTitle
    }
  }), [quoteTitle]);
  const renderDescription = useCallback(() => {
    if (quoteFullySigned) {
      return /*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "strong",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'quotesUiLib.deleteQuoteModal.description.signed.title'
          })
        }), /*#__PURE__*/_jsxs(UIFlex, {
          direction: "column",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: 'quotesUiLib.deleteQuoteModal.description.signed.body.one'
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'quotesUiLib.deleteQuoteModal.description.signed.body.two'
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'quotesUiLib.deleteQuoteModal.description.signed.body.three'
          })]
        })]
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: quotePublished ? 'quotesUiLib.deleteQuoteModal.description.published' : 'quotesUiLib.deleteQuoteModal.description.default'
    });
  }, [quotePublished, quoteFullySigned]);
  const description = useMemo(() => {
    return /*#__PURE__*/_jsx(View, {
      marginBlockStart: "400",
      as: "div",
      children: renderDescription()
    });
  }, [renderDescription]);
  if (!isOpen) {
    return null;
  }
  const confirmLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "quotesUiLib.deleteQuoteModal.confirm"
  });
  const cancelLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "quotesUiLib.deleteQuoteModal.cancel"
  });
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    "data-test-id": "delete-quote-modal",
    message: title,
    size: "auto",
    use: "danger",
    confirmUse: "danger",
    description: description,
    ConfirmButton: LoadingButton,
    confirmButtonProps: {
      loading
    },
    onConfirm: onConfirm,
    onReject: onReject,
    confirmLabel: confirmLabel,
    rejectLabel: cancelLabel
  });
};
export default /*#__PURE__*/memo(DeleteQuoteModal);